import * as ChangeLanguageActions from 'actions/changeLanguage';

import * as RepositoryState from 'constants/RepositoryState';

export default function commonStateReducer(state, action) {
    switch (action.type) {
        case ChangeLanguageActions.CHANGE_LANGUAGE:
            return RepositoryState.NOT_INITED;
    }

    return state;
}



// WEBPACK FOOTER //
// ./js/shared/reducers/entities/commonStateReducer.js